module.exports = __webpack_public_path__ + "img/bg_exclusive-party-areas-2.16ca4998.jpeg";